import { SvgIcon, SvgIconProps } from '@mui/material';
import { white, yellow } from '@/lib/colours';

export function StarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 10 10">
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_377_44492)">
          <rect width="10" height="10" rx="5" fill={white[900]} />
          <path
            d="M4.99648 0.833496C2.69648 0.833496 0.833984 2.70016 0.833984 5.00016C0.833984 7.30016 2.69648 9.16683 4.99648 9.16683C7.30065 9.16683 9.16732 7.30016 9.16732 5.00016C9.16732 2.70016 7.30065 0.833496 4.99648 0.833496ZM6.34232 7.246L5.00065 6.43766L3.65898 7.246C3.50065 7.34183 3.30482 7.20016 3.34648 7.021L3.70065 5.496L2.52148 4.47516C2.38398 4.35433 2.45898 4.12516 2.64232 4.1085L4.20065 3.97516L4.80898 2.53766C4.87982 2.36683 5.12148 2.36683 5.19232 2.53766L5.80065 3.971L7.35898 4.10433C7.54232 4.121 7.61732 4.35016 7.47565 4.471L6.29648 5.49183L6.65065 7.021C6.69232 7.20016 6.50065 7.34183 6.34232 7.246Z"
            fill={yellow[500]}
          />
        </g>
        <defs>
          <clipPath id="clip0_377_44492">
            <rect width="10" height="10" rx="5" fill={white[900]} />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
